import type { User } from 'types';

export const getHasChildrenSetupCompleted = (
  user?: Pick<User, 'childrenCount' | 'childrenSetupRequiredCount'> | null
): boolean => {
  const { childrenCount, childrenSetupRequiredCount } = user ?? {};
  return (childrenCount ?? 0) > 0 && childrenSetupRequiredCount === 0;
};
